import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "translateStringCutter" })
export class TranslateStringCutter implements PipeTransform {
  transform(value: string, index: string): string {
    const cutIndex = Number(index);
    return value.split("|")[cutIndex];
  }
}
